
export default {
    inserted: function (el) {
        el.addEventListener('click', function(e) {
            e.preventDefault();
            this.classList.toggle('active');
        });
    }
};



// WEBPACK FOOTER //
// ./src/app/directives/toggle-credit-image.js